module.exports = __webpack_public_path__ + "static/media/image-video-9.09163ef3.png";